var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"p-0 d-flex align-items-start"},[_c('span',{class:"badge badge-pill issue-status-pill" + _vm.statusClass},[_vm._v(_vm._s(_vm.ticketId? '#' + _vm.ticketId: 'No Ticket-Id'))])])}
var staticRenderFns = []

export { render, staticRenderFns }